/* istanbul ignore file */
import { ApiResultError } from '@codegrade/api-core';
import { AnyError } from '@codegrade/api-models';
import { cache, parsers } from '@codegrade/utils';
const parseJsonResponse = parsers.parseJsonResponse;
function parseError(parser) {
    return async (response) => {
        const parsed = await parser(response);
        return ApiResultError.fromResponse(parsed, response);
    };
}
const BASE_ERRORS = Object.freeze({
    400: /* #__PURE__ */ parseError(/* #__PURE__ */ parseJsonResponse(AnyError)),
    401: /* #__PURE__ */ parseError(/* #__PURE__ */ parseJsonResponse(AnyError)),
    403: /* #__PURE__ */ parseError(/* #__PURE__ */ parseJsonResponse(AnyError)),
    404: /* #__PURE__ */ parseError(/* #__PURE__ */ parseJsonResponse(AnyError)),
    409: /* #__PURE__ */ parseError(/* #__PURE__ */ parseJsonResponse(AnyError)),
    429: /* #__PURE__ */ parseError(/* #__PURE__ */ parseJsonResponse(AnyError)),
    500: /* #__PURE__ */ parseError(/* #__PURE__ */ parseJsonResponse(AnyError)),
});
export function makeResponses(responses) {
    return new cache.Cache(() => ({ ...BASE_ERRORS, ...responses }));
}
